import { render } from "./homeSubTopicManager.vue?vue&type=template&id=99c48890&scoped=true"
import script from "./homeSubTopicManager.vue?vue&type=script&lang=js"
export * from "./homeSubTopicManager.vue?vue&type=script&lang=js"

import "./homeSubTopicManager.vue?vue&type=style&index=0&id=99c48890&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c48890"]])

export default __exports__